/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Kullanim_S8_I2Inputs */

const tr_kullanim_s8_i2 = /** @type {(inputs: Kullanim_S8_I2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`API anahtarları AES-256-GCM ile veritabanında şifrelenmiş olarak saklanır.`)
};

const en_kullanim_s8_i2 = /** @type {(inputs: Kullanim_S8_I2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`API keys are stored encrypted in the database with AES-256-GCM.`)
};

const de_kullanim_s8_i2 = /** @type {(inputs: Kullanim_S8_I2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`API-Schlüssel werden mit AES-256-GCM verschlüsselt in der Datenbank gespeichert.`)
};

const ru_kullanim_s8_i2 = /** @type {(inputs: Kullanim_S8_I2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`API-ключи хранятся в базе данных в зашифрованном виде с использованием AES-256-GCM.`)
};

/**
* | output |
* | --- |
* | "API keys are stored encrypted in the database with AES-256-GCM." |
*
* @param {Kullanim_S8_I2Inputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const kullanim_s8_i2 = /** @type {((inputs?: Kullanim_S8_I2Inputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Kullanim_S8_I2Inputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_kullanim_s8_i2(inputs)
	if (locale === "de") return de_kullanim_s8_i2(inputs)
	if (locale === "ru") return ru_kullanim_s8_i2(inputs)
	return tr_kullanim_s8_i2(inputs)
});